import {
  REQUEST_OUTDOOR_DATA,
  OUTDOOR_DATA_FAILED,
  OUTDOOR_DATA_SUCCESS,
} from '../actions/types';

export const outdoorReducers = (
  state = {
    loading: true,
  },
  action,
) => {
  switch (action.type) {
    case REQUEST_OUTDOOR_DATA:
      return { loading: true };
    case OUTDOOR_DATA_SUCCESS:
      return { loading: false, data: action.payload};
    case OUTDOOR_DATA_FAILED:
      return { loading: false };
    default:
      return state;
  }
};
